import { Typography } from '@mui/material'
import React, { ComponentPropsWithRef, memo } from 'react'
import type { TypographyVariant } from '../../types/mui'
import _ from 'lodash'

export type DFType = 'big' | 'small' | 'none'
// @ts-ignore TS2307
interface Props extends ComponentPropsWithRef<typeof Typography> {
    fontType: DFType
    fullTitle: string
    textSize: TypographyVariant
}


function countWords(text: string): number {
    // Regular expression to match words
    const regex = /\b\w+\b/g
    // Find matches in the text
    const matches = text.match(regex)
    // Return the number of matches, or 0 if there are none
    return matches ? matches.length : 0
}

// MAX 2 lines
const SizeMap: Record<DFType, Record<number, string>> = {
    'big': {
        // 1: 'text-[3.5vh]', // [0,2.5]
        5: 'text-[3vh]',
        10: 'text-[2.8vh]',
        15: 'text-[2.6vh]',
        20: 'text-[2.4vh]', // FIXME to test
    },
    'small': {
        // 1: 'text-[3.5vh]', // [0,2.5]
        5: 'text-[2.4vh]',
        10: 'text-[2.2vh]',
        15: 'text-[2vh]',
        20: 'text-[1.8vh]',
    },
    'none': {},
}

const sizeFromCount = (nWords: number, fontType: DFType) => {
    const sizeMap = SizeMap[fontType]
    const keys = Object.keys(sizeMap).map(Number)
    const closest = _.minBy(keys, (n) => Math.abs(n - nWords))
    return closest ? sizeMap[closest] : 'text-[1vh]'
}

//@ts-ignore
export const DynamicFont = memo((p: Props) => {
    const { fullTitle, textSize, fontType = 'none', ...restProps } = p
    const nWords = countWords(fullTitle)
    // and not flex-1 embedded (PARENT must be flex 1)
    return (
        <Typography
            variant={textSize}
            className={
                // FIXME
                fontType !== 'none'
                    ? `${sizeFromCount(nWords, fontType)} text-center flex-1 leading-none`
                    : 'text-center flex-1 leading-none'
            }
        >
            {fullTitle}
        </Typography>
    )
})
